import React from "react";

const CallIcon = ({ width, height, color }) => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17" fill="#00008B" stroke="black" />
      <path
        d="M25.3443 22.3055V24.8491C25.3452 25.0852 25.2968 25.3189 25.202 25.5353C25.1072 25.7517 24.9682 25.9459 24.7938 26.1055C24.6195 26.2651 24.4136 26.3867 24.1895 26.4623C23.9654 26.538 23.7279 26.5661 23.4922 26.5448C20.878 26.2613 18.3669 25.3698 16.1606 23.9419C14.1079 22.6401 12.3676 20.9032 11.0633 18.8546C9.6275 16.6427 8.734 14.1244 8.45514 11.5036C8.43391 11.2691 8.46183 11.0328 8.53712 10.8097C8.61241 10.5866 8.73343 10.3816 8.89246 10.2077C9.05149 10.0339 9.24506 9.89493 9.46083 9.79981C9.67661 9.70469 9.90986 9.65546 10.1458 9.65523H12.6944C13.1067 9.65118 13.5064 9.79689 13.819 10.0652C14.1316 10.3335 14.3358 10.7061 14.3935 11.1136C14.5011 11.9276 14.7006 12.7268 14.9882 13.4961C15.1025 13.7996 15.1272 14.1294 15.0595 14.4464C14.9917 14.7635 14.8343 15.0546 14.6059 15.2851L13.527 16.3619C14.7364 18.4846 16.4974 20.2421 18.6243 21.4491L19.7032 20.3723C19.9342 20.1444 20.2258 19.9873 20.5435 19.9196C20.8612 19.852 21.1917 19.8767 21.4958 19.9908C22.2666 20.2778 23.0674 20.4769 23.883 20.5843C24.2957 20.6424 24.6726 20.8498 24.942 21.1672C25.2115 21.4845 25.3546 21.8896 25.3443 22.3055Z"
        stroke="#FAFAFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CallIcon;
